import React from "react";

// Reveals text by sliding a block up from the bottom.
// Use inside a container with the `rv` class or pair with useReveal.
export default function TextReveal({ children, delay = 0, className = "" }) {
  return (
    <span className={`reveal-clip ${className}`}>
      <span style={{ transitionDelay: `${delay}ms` }}>{children}</span>
    </span>
  );
}
